import React, { type FunctionComponent, Fragment } from 'react'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import DocumentTitle from 'legacy/components/DocumentTitle'
import { CollectionsListContainer } from 'domains/collections/components/collections-list/CollectionsListContainer'
import { navCollectionsAdminRoutingConfig } from 'domains/collections/utils/navCollectionsRoutingConfig'
import { CollectionTypeEnum } from 'domains/collections/api'
import { NavCollectionsListHeader } from 'domains/collections/components/collections-list/components/header/NavCollectionsListHeader'

interface Props extends DashRouteComponentProps<{}> {}

export const NavCollectionsAdminListPage: FunctionComponent<Props> = ({ match }) => (
  <Fragment>
    <DocumentTitle titleId="navCollectionsDomain.list.title" />

    <NavCollectionsListHeader routingConfig={navCollectionsAdminRoutingConfig} />

    <CollectionsListContainer
      retailerId=""
      routingConfig={navCollectionsAdminRoutingConfig}
      collectionType={CollectionTypeEnum.Department}
    />
  </Fragment>
)
